import { mapEntityProperties } from '@/utils/mapEntityProperties'
import { SpinWheelMiniEntity } from '../../domain/entities/SpinWheelMiniEntity'

export class SpinWheelMiniModel extends SpinWheelMiniEntity {
  constructor(dataDto: SpinWheelMiniEntity) {
    super()
    mapEntityProperties<SpinWheelMiniModel>(this, dataDto)
  }
}
